module.exports = __webpack_public_path__ + "img/blue.353c2008.svg";